import React from "react";
import SupportLayout from "../support/SupportLayout";
import AdminInterventionsContent from "./components/AdminInterventionsContent";

const AdminInterventions = () => {
  return (
    <SupportLayout userRole="ADMIN">
      <AdminInterventionsContent userRole="ADMIN" />
    </SupportLayout>
  );
};

export default AdminInterventions;
